var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWord(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 4,
    fill: "#1E88E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_187_4660)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.915 4.00796L4.195 5.28296C4.08156 5.30452 4 5.40764 4 5.52296V14.478C4 14.5933 4.08156 14.6964 4.195 14.718L10.915 15.993C10.93 15.9958 10.945 16.0005 10.96 16.0005C11.0153 16.0005 11.0669 15.9836 11.11 15.948C11.1653 15.902 11.2 15.8317 11.2 15.7605V4.24046C11.2 4.16921 11.1653 4.09889 11.11 4.05296C11.0547 4.00702 10.9853 3.99483 10.915 4.00796ZM11.68 5.44046V7.12046H14.56V7.60046H11.68V8.80046H14.56V9.28046H11.68V10.4805H14.56V10.9605H11.68V12.4005H14.56V12.8805H11.68V14.5605H15.28C15.5444 14.5605 15.76 14.3448 15.76 14.0805V5.92046C15.76 5.65608 15.5444 5.44046 15.28 5.44046H11.68ZM5.11 7.75796H5.965L6.4525 10.743C6.47406 10.8695 6.48813 11.0458 6.4975 11.2605H6.5125C6.51906 11.1001 6.54719 10.9258 6.5875 10.7355L7.2175 7.75796H8.0575L8.6275 10.773C8.64813 10.8836 8.66406 11.042 8.68 11.253H8.6875C8.69406 11.088 8.71188 10.9192 8.74 10.7505L9.22 7.75796H10.015L9.0925 12.243H8.2225L7.645 9.37046C7.61406 9.22046 7.59906 9.04608 7.5925 8.86046H7.585C7.57 9.06483 7.54469 9.23827 7.5175 9.37046L6.925 12.243H6.025L5.11 7.75796Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_187_4660"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWord);
export default __webpack_public_path__ + "static/media/word.4b92d3996b8785971f141f4e1e8996c3.svg";
export { ForwardRef as ReactComponent };